import controller from './filter-panel-toggler-controller';

const FilterPanelTogglerComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    onToggle: '&',
    isInReportViewer: '<?',
  },
  template: `
    <button class="btn btn-secondary ds toggler-button"
      ng-click="ctrl.handleClick(ctrl.filterPanelIsOpen$ | async:this)"
      ng-dblclick="$event.stopPropagation()"
      data-test="filter-toggle">
      <i ng-if="ctrl.isInReportViewer" class="icon-filter-outline-mini"></i>
      {{ (ctrl.filterPanelIsOpen$ | async:this) ? 'Hide filters' : 'Filters' }}
    </button>
  `,
};

export { FilterPanelTogglerComponent };
